import TooltipContainer from './TooltipContainer.component';

export default TooltipContainer;
